module.exports = __webpack_public_path__ + "static/media/Logo REVCON_Rojo-Blanco.476d9c01.png";